var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkOff1X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons/bookmark_off"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 16,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6C24 4.89543 23.1046 4 22 4H10C8.89543 4 8 4.89543 8 6V26.1958C8 26.3832 8.05267 26.5668 8.152 26.7258C8.44471 27.1941 9.06166 27.3365 9.53 27.0438L15.47 23.3312C15.7943 23.1286 16.2057 23.1286 16.53 23.3312L22.47 27.0438C22.6289 27.1431 22.8126 27.1958 23 27.1958C23.5523 27.1958 24 26.748 24 26.1958V6ZM10 6H22V24.392L17.59 21.6353L17.4047 21.5284C16.4639 21.0296 15.322 21.0652 14.41 21.6353L10 24.391V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75 Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 11",
    width: 32,
    height: 32,
    fill: "#E8703C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOff1X);
export default __webpack_public_path__ + "static/media/bookmark_off@1x.cd5aea750d3af98513dd0a712ee14de6.svg";
export { ForwardRef as ReactComponent };